import { makeStyles } from '@material-ui/core/styles';
import fonts from 'styles/fonts';

const useStyles = makeStyles({
  formMessage: {
    fontSize: '14px',
    fontWeight: fonts.weights.normal,
    letterSpacing: '0.15px',
    lineHeight: '16px',
    marginBottom: '30px',
  },
  bodyContent: {
    flexGrow: 1,

    '& > div:first-child': {
      paddingBottom: '34px',
    },
    '& > div': {
      paddingBottom: '24px',
    },
    '& > div:last-child': {
      paddingBottom: '0',
    },
  },
  footer: {
    '& > button': {
      marginLeft: '6px',
    },
  },
  formScroll: {
    overflowY: 'scroll',
    overflowX: 'hidden',
    height: '400px',
  },
  divider: {
    marginTop: '30px',
    height: '2px',
    width: '580px',
    background: 'rgba(0, 0, 0, 0.3)',
  },
});

export default useStyles;
